import * as React from 'react';
import { useCallback } from 'react';
import classNames from 'classnames';
import { UIText2 } from '@cian/ui-kit';

import { getDurationText } from '../../utils';
import { Discount } from '../Discount';
import * as styles from './Duration.css';

export interface IDurationProps {
  duration: number;
  discount: number;
  checked: boolean;
  isPromoDiscount: boolean;
  disabled?: boolean;

  onClick({ duration, discount }: { duration: number; discount: number }): void;
}

export const Duration = ({ duration, discount, checked, disabled, isPromoDiscount, onClick }: IDurationProps) => {
  const handleClick = useCallback(() => {
    if (!disabled) {
      onClick({ duration, discount });
    }
  }, [disabled, discount, duration, onClick]);

  return (
    <div
      className={classNames(styles['card'], checked && styles['checked'], disabled && styles['disabled'])}
      onClick={handleClick}
      data-testid="duration"
      data-checked={checked}
    >
      <UIText2 color={disabled ? 'gray40_100' : 'black_100'}>{getDurationText(duration)}</UIText2>
      <Discount disabled={disabled} discount={discount} isPromoDiscount={isPromoDiscount} />
    </div>
  );
};
